import React, { Component } from "react";
import "./realestatedashboard.css";
import { t } from "i18next";
import {
  BreadCrumb,
  Button,
  Header,
  TitleView,
  CardDetailContainer,
  SideModel, Toast,
  ProgressDialog
} from "../../components";
import * as Bl from "../../../businesslogic";
import { getInvestmentPhysicalPath, getUserId } from "../../common";
import { FIXED_ASSETS_TYPE } from "../../constants";
import { getFormatAmount } from "../../common";
import * as logger from "../../utils/logger/index";

class RealEstateDashBoard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showEditView: false,
      showModal: false,
      editing: null,
      title: "",
      fixedAssetsData: []

    };
    this.isRenderingAlready = false;

  }
  componentDidMount() {
    if (!this.isRenderingAlready) {
      this.isRenderingAlready = true;
      this.getUserFixedAssetsByType();
    }
  }

  onSelectItem(path) {
    this.props.navigate(path);
  }

  onPressAddMoreView() {
    this.props.navigate('/realestatehome')
  }

  onPressSaveButton() {
    this.props.navigate('/financialdetails')
  }

  onClickEditIcon = (selectedItem) => {
    const fixedAssetData = selectedItem.item;
    fixedAssetData.assetinflation = (fixedAssetData.assetinflation * 100).toFixed(2)
    this.props.navigate('/realestatedetail', {
      state: { fixedAssetsData: fixedAssetData, isEditView: true },
    });
  };

  onPressNo = () => {
    this.setState({ showModal: false });
  };

  onPressYes = (selectedItem) => {
    this.deleteInvestment(selectedItem.item);
  };
  hideToast() {
    this.setState({ toastMessage: "", showToast: false });
  }

  showToast(toastMessage) {
    this.setState(
      { toastMessage, showToast: true, showProgress: false },
      () => {
        setTimeout(() => {
          this.hideToast();
        }, 3000);
      }
    );
  }
  getTotalBalance(list) {
    const totalArray = [];
    list.forEach((item) => {
      totalArray.push({
        money: item.currentvalue,
      });
    });
    const total = totalArray.reduce((a, v) => (a = a + v.money), 0);
    return total;
  }
  prepareCardData(list) {
    const displayData = [];
    list.forEach((item) => {
      displayData.push({
        title: item?.fixedassetdescription,
        currencyLabel: "Current Value",
        money: item?.currentvalue,
        extraContent: item?.isliquidated ? "Planned for Liquidation / Sell" : "",
        item,
      });
    });
    return displayData;
  }
  getUserFixedAssetsByType() {
    const data = {
      uuid: getUserId(),
      type: FIXED_ASSETS_TYPE.REAL_ESTATE,
    };

    this.setState({ showProgress: true }, () => {
      Bl.FixedAsset.getUserFixedAssetsByType(data)
        .then((list) => {
          this.setState({ showProgress: false, fixedAssetsData: list });
        })
        .catch((error) => {
          logger.error({ error })
          this.showToast(t("someErrorHasOccured"));
        });
    });
  }

  deleteInvestment(item) {
    const fixedAssetsObj = new Bl.FixedAsset(item);
    this.setState({ showProgress: true }, () => {
      fixedAssetsObj.deleteFixedAssets()
        .then(() => {
          const newList = this.state.fixedAssetsData && this.state.fixedAssetsData.filter(e => e.id !== item.id)
          this.setState({ fixedAssetsData: newList, showProgress: false })
        })
        .catch((error) => {
          logger.error({ error })
          this.showToast(t("someErrorHasOccured"));
        });
    })

  }



  renderNavView() {
    const items = getInvestmentPhysicalPath("RealEstate");
    const location = this.props.location;
    return (
      <BreadCrumb
        items={items}
        isLastPath={true}
        currentPath={location.pathname}
        onClickBackIcon={this.onSelectItem.bind(this)}
        onClickItem={this.onSelectItem.bind(this)}
      />
    );
  }

  renderTitleView() {
    const title = t("networthAssetsPA1");
    return <TitleView title={title} information={""} />;
  }



  renderExpectedValueView() {
    const totalBalance = this.getTotalBalance(this.state.fixedAssetsData);
    const displayAmount = getFormatAmount(totalBalance);
    return (
      <div className="rsdb_expect_value_view">
        <label className="rsdb_value_text">
          {t("realdbValue")}:  ₹ {displayAmount}
        </label>
      </div>
    );
  }

  renderCardView() {
    const cardData = this.prepareCardData(this.state.fixedAssetsData);

    return (
      <div className="rsdb_card_view">
        {cardData.map((card, index) => (
          <CardDetailContainer
            key={index}
            title={card.title}
            currentValue={card.currencyLabel}
            money={card.money}
            extraContent={card.extraContent}
            onClickEdit={() => this.onClickEditIcon(card)}
            onPressNo={this.onPressNo.bind(this)}
            onPressYes={() => this.onPressYes(card)}
          />
        ))}
      </div>
    );
  }


  renderContentView() {
    return (
      <div className="rsdb_content_view">
        {this.renderTitleView()}
        {this.renderExpectedValueView()}
        {this.renderCardView()}
      </div>
    );
  }

  renderButtonsView() {
    return (
      <div className="rsdb_bottomView">
        <div className="rsdb_buttonView">
          <div className="rsdb_addmore_button">
            <Button
              buttonName={t("realdbButton1")}
              emptyButton={true}
              onPressButton={this.onPressAddMoreView.bind(this)}
            />
          </div>
          <div className="rsdb_save">
            <Button
              buttonName={t("realdbButton2")}
              onPressButton={this.onPressSaveButton.bind(this)}
            />
          </div>
        </div>
      </div>
    );
  }
  renderDrawerContent() {
    const headerTitle = t("financialPlan");
    const step = 1;
    return <SideModel step={step} headerTitle={headerTitle}></SideModel>;
  }

  renderToastView() {
    return (
      <Toast
        showToast={this.state.showToast}
        toastMessage={this.state.toastMessage}
      />
    );
  }

  renderProgressDialog() {
    return (
      <ProgressDialog
        showProgress={this.state.showProgress}
        progressMessage={this.state.progressMessage}
      />
    );
  }
  render() {
    return (
      <div className="rsdb_container">
        {this.renderNavView()}
        {this.renderContentView()}
        {this.renderButtonsView()}
        {/* {this.renderDrawerContent()} */}
        {this.renderToastView()}
        {this.renderProgressDialog()}
      </div>
    );
  }
}

export default RealEstateDashBoard;
